module.exports = __webpack_public_path__ + "img/pro-m-slider23.1138b855.png";